// Season config lives in src/shared/seasons.js so the api/ functions can load
// the same file. This alias keeps the existing `import ... from '../config/seasons'`
// paths working in the browser.
module.exports = require('../shared/seasons');
